/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/indent */
import { useEffect, useLayoutEffect } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import ErrorTemplate from '@/components/templates/Error';
import RaceCardsTemplate from '@/components/templates/RaceCard';
import { DATE_PARAM_KEY } from '@/config/constants/query';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { useUserContext } from '@/contexts/user';
import {
  RaceProgram,
  useGetEntryRacerNoteCountsLazyQuery,
  useGetRaceProgramsLazyQuery,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';

const RaceCardPage: React.FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const location = useLocation();
  const { isMember } = useUserContext();

  const paramDate = new URLSearchParams(location.search).get(DATE_PARAM_KEY);
  const targetDate = paramDate ? dayjst(paramDate) : dayjst();

  const [loadRacePrograms, raceProgramsQuery] = useGetRaceProgramsLazyQuery();
  const [loadRacerNoteCounts, racerNoteCountsQuery] =
    useGetEntryRacerNoteCountsLazyQuery();

  const getCommentCount = (raceId: string) => {
    if (isMember) {
      if (racerNoteCountsQuery.data) {
        const racerNoteCount =
          racerNoteCountsQuery.data.entryRacerNoteCounts.find(
            r => r.raceID === raceId,
          );
        if (racerNoteCount) {
          return racerNoteCount.count !== 0;
        }
      }
    }
    return false;
  };

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '出走表一覧',
        to: '/racecard',
      },
      {
        name: targetDate.format('YYYY年M月D日'),
        to: '',
      },
    ]);
    loadRacePrograms({
      variables: {
        input: {
          heldDate: targetDate,
        },
      },
    });
    if (isMember) {
      loadRacerNoteCounts({
        variables: {
          heldDate: targetDate,
        },
      });
    }
  }, [paramDate]);

  const title = `${targetDate.format('YYYY年M月D日')}の出走表`;

  return (
    <>
      <Helmet
        meta={{
          title: `競輪 ${title}`,
          description: '競輪の出走表です。%s',
          keywords: `${title},%s`,
        }}
      />
      {raceProgramsQuery.error ? (
        <ErrorTemplate apolloError={raceProgramsQuery.error} />
      ) : (
        <RaceCardsTemplate
          date={targetDate}
          racePrograms={
            (raceProgramsQuery.data?.racePrograms || []) as RaceProgram[]
          }
          loading={raceProgramsQuery.loading}
          getCommentCount={getCommentCount}
        />
      )}
    </>
  );
};
export default RaceCardPage;
